import * as Core from '@skylab-shared/core';
import { InventoryDocumentKind } from '../inventory/inventory-document-kind';
import { SaleDocumentKind } from '../sale/sale-document-kind';
import { PrintingPatternLanguage } from './printing-pattern-language';

export class PrintingPatternGridColumnDefinition extends Core.ModelBase {
    @Core.Property()
    public id: string;

    @Core.Property()
    public width: number;
}

export class PrintingPatternGridDefinition extends Core.ModelBase {
    @Core.Collection({ type: PrintingPatternGridColumnDefinition })
    public columns: Core.ObservableCollection<PrintingPatternGridColumnDefinition>;
}

export class DocumentPrintingPatternModel extends Core.ModelBase {
    @Core.Property()
    public baseCurrencyDocumentGross: boolean;

    @Core.Property()
    public baseCurrencyVatTable: boolean;

    @Core.Property()
    public deliveryAddress: boolean;

    @Core.Property()
    public documentNote: boolean;

    @Core.Property()
    public exchangeRate: boolean;

    @Core.Property()
    public explainSaleDate: boolean;

    @Core.Property()
    public issuer: boolean;

    @Core.Property()
    public itemNote: boolean; //opis pozycji

    @Core.Property()
    public leftToPay: boolean;

    @Core.Property()
    public logo: boolean;

    @Core.Property()
    public productNote: boolean;

    @Core.Property()
    public recipient: boolean;

    @Core.Property()
    public relatedClientTIN: boolean;

    @Core.Property()
    public sourceDocumentInfo: boolean;

    @Core.Property()
    public vatTableWhenReverseCharge: boolean;

    @Core.Property()
    public vatTable: boolean;

    @Core.Property()
    public jpkCodes: boolean;

    @Core.Property()
    public unsettledDocuments: boolean;

    @Core.Property()
    public previousAdvancesList: boolean;

    @Core.Property()
    public payments: boolean;

    @Core.Property()
    public ksefNumber: boolean;

    @Core.Property()
    public summary: boolean;
}

export class PrintingPatternModel extends Core.ModelBase {
    @Core.Property({ identifiable: true })
    public id: number;

    @Core.Property()
    public default: boolean;

    @Core.Property()
    public disableShadows: boolean;

    @Core.Property()
    @Core.VeryLongString('data-model.printing-pattern.validation.document-title.length')
    public documentTitle: string;

    @Core.Property()
    @Core.VeryLongString('data-model.printing-pattern.validation.document-title-final-advance.length')
    public finalAdvanceDocumentTitle?: string;

    @Core.Property()
    public includes: DocumentPrintingPatternModel;

    @Core.Property()
    public itemsList: PrintingPatternGridDefinition;

    @Core.Property()
    public kind: SaleDocumentKind | InventoryDocumentKind;

    @Core.Property()
    @Core.MaxString('data-model.printing-pattern.validation.company-note.length')
    public myCompanyNote: string;

    @Core.Property()
    @Core.NormalString('data-model.printing-pattern.validation.name.length')
    @Core.Required('data-model.printing-pattern.validation.name.no-empty')
    public name: string;

    @Core.Property()
    @Core.MaxString('data-model.printing-pattern.validation.note.length')
    public note: string;

    @Core.Property(String, { nullable: true })
    public secondaryLanguage: PrintingPatternLanguage | null;
}
